import type { MonitoringTab } from '@cobliteam/monitoring/src/hooks/useMonitoringTabs';

import type { NamedAction } from '../createNamedReducer';
import type { GenericSheet } from './parser/types';

// TODO: use actionSanitizer to avoid repetition. Inspired by https://medium.com/@Alserda/readable-ts-enum-actiontypes-in-react-redux-c105fa0a7c9b
export enum SpreadsheetActionTypes {
  PARSE_SPREADSHEET_START = 'PARSE_SPREADSHEET_START',
  PARSE_SPREADSHEET_FAIL = 'PARSE_SPREADSHEET_FAIL',
  PARSE_SPREADSHEET_SUCCESS = 'PARSE_SPREADSHEET_SUCCESS',
}

export interface ParseSpreadsheetStart extends NamedAction {
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_START;
  domain: MonitoringTab;
  payload: File;
}

export interface ParseSpreadsheetFail extends NamedAction {
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_FAIL;
  domain: MonitoringTab;
}

export interface ParseSpreadsheetSuccess extends NamedAction {
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_SUCCESS;
  domain: MonitoringTab;
  payload: GenericSheet<unknown>;
}

export type ParseSpreadsheetAction = ParseSpreadsheetStart | ParseSpreadsheetFail | ParseSpreadsheetSuccess;
